<template>
    <DropMenu
        :value="headers.filter(h => visibleHeaders.includes(h.value))"
        :items=items
        value-key="value"
        name-key="text"
        :menu-state="menuState"
        multi
        deselect
        searchable
        show-selected-first
        :toggle-select="false"
        :menu-props="{ offsetY: true, left: true }"
        @update:menuState="menuState = $event"
        @input="onInput"
    >
        <template v-slot="{ on: menuOn }">
            <slot>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltipOn }">
                        <icon-button
                            icon="Table"
                            :on="{ ...menuOn, ...tooltipOn }"
                        />
                    </template>
                    {{ $t('Edit fields') }}
                </v-tooltip>
            </slot>
        </template>
    </DropMenu>
</template>

<script>

import DropMenu from "./NewFilterBar/components/DropMenu";
import { isVisible, toggleVisibility } from "@/helpers/DataTableHelpers";
import { ref, computed } from "@vue/composition-api";
import DialogModule from "../store/modules/dialog";
import { $t } from "@/i18n";

export default {
    name: "ColumnController",
    components: {
        DropMenu
    },
    props: {
        headers: {
            type: Array,
            required: true
        },
        onChangeFunc: {
            type: Function,
            default: () => []
        },
        visibleHeaders: {
            type: Array,
            default: () => [],
        },
        maxHeaders: {
            type: Number,
            default: 99
        },
        dense: {
            type: Boolean,
            default: false
        }
    },
    setup(props, ctx) {
        const { openError, setErrorOptions } = DialogModule();
        const visible_headers = ref(props.visibleHeaders.map(h => h));
        const menuState = ref(false)
        const items = computed(() => {
            return props.headers.filter(x => x.text)
        })
        const onInput = val => {
            if (val.length > props.maxHeaders) {
                setErrorOptions({
                    title: $t("Maximum number of selected columns has been exceeded"),
                    text: $t("If you want to add a new column to the report, please remove an existing one first.")
                });
                openError();
                visible_headers.value = [...visible_headers.value];
            } else {
                visible_headers.value = val.map(h => h.value);
            }
            ctx.emit("update_columns", visible_headers.value);
        };

        return {
            isVisible,
            toggleVisibility,
            onInput,
            items,
            menuState
        };
    }
};

</script>